<template>
  <!-- start contact -->
  <div id="contact">
    <div class="container">
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-4 wow fadeInLeft" data-wow-delay="0.6s">
          <h2><strong>Printer Counters</strong></h2>
          <p>Printer Counters - ePaper LTD</p>
          <p>Katom st. 8, Industrial Park Misgav, Israel</p>
          <p>+972-73-215-29-29</p>
          <p>support@epapersign.com</p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-5">
          <div class="box-header with-border">
            <h3 class="control-label" style="color: #fff;">Contact Us</h3>
          </div>
          <div class="box-body">
            <div>
              <form action="#" method="post" class="form-horizontal" id="contact-form" role="form">
                <div class="form-group">
                  <span class="col-sm-3 control-label">Full Name</span>
                  <div class="col-sm-9">
                    <input type="text" @keydown="isTyping = true" v-model="contact.FullName" placeholder="Full Name" class="form-control">
                  </div>
                </div>
                <div class="form-group">
                  <span class="col-sm-3 control-label">Email Address</span>
                  <div class="col-sm-9">
                    <input type="text" @keydown="isTyping = true" v-model="contact.Email" maxlength="50" placeholder="Email Address" class="form-control">
                  </div>
                </div>
                <div class="form-group">
                  <span class="col-sm-3 control-label">Message</span>
                  <div class="col-sm-9">
                    <textarea name="message" @keydown="isTyping = true" v-model="contact.Message" rows="5" class="form-control" id="message" placeholder="Message"></textarea>
                  </div>
                </div>
                <div class="form-group" align="center">
                  <span class="col-sm-3 control-label"></span>
                  <va-alert class="col-sm-9" type="danger" :dismissible="true" v-show="error">
                    <div slot="body">
                      <i class="icon fa fa-ban"></i> {{error}}
                    </div>
                  </va-alert>
                </div>
                <div class="form-group">
                  <div class="col-sm-12">
                    <input name="send" type="button" class="form-control pull-right" style="width: 150px;" id="send" value="Send" @click="sendEmail()">
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- end contact -->
</template>
<script>
  import { db } from '../../firebase'
  import VAAlert from '../VAAlert'
  export default {
    name: 'contact',
    components: { 'va-alert': VAAlert },
    data () {
      return {
        contact: { Logged: '', LoggedInt: 0, FullName: '', Email: '', Message: '', IsRead: false },
        error: '',
        isTyping: false
      }
    },
    computed: {
    },
    watch: {
      isTyping (val) {
        if (val) {
          this.error = ''
        }
      }
    },
    methods: {
      sendEmail () {
        let vm = this
        vm.isTyping = false
        if (vm.isValid()) {
          try {
            var now = vm.$moment()
            console.log(now)
            vm.contact.Logged = vm.$moment().format('YYYY-MM-DD HH:mm:ss')
            vm.contact.LoggedInt = Number(vm.$moment(vm.contact.Logged, 'YYYY-MM-DD HH:mm:ss').format('YYYYMMDDHHmm'))
            const contactRef = db.ref('Contact')
            contactRef.push(vm.contact)
            vm.resetContact()
            vm.$notify({
              type: 'success',
              title: 'Contact Us',
              text: 'Your message was sent successfully, we will contact you back soon.'
            })
          } catch (e) {
            vm.error = e.message
          }
        }
      },
      resetContact () {
        let vm = this
        vm.contact = { Logged: '', LoggedInt: 0, FullName: '', Email: '', Message: '', IsRead: false }
      },
      isValid () {
        this.error = ''

        if (!this.contact.FullName || this.contact.FullName.length === 0) {
          this.error = '* Please enter your full name!'
          return false
        }

        if (!this.contact.Email || this.contact.Email.length === 0) {
          this.error = '* Please enter your email address!'
          return false
        }

        if (!this.contact.Message || this.contact.Message.length === 0) {
          this.error = '* Please enter your message!'
          return false
        }

        return true
      }
    }
  }
</script>
<style>
  #contact {
    background: url(../../../static/img/bottom.jpg);
    background-size: cover;
    background-repeat: no-repeat;
    color: #ffffff;
    padding: 30px;
  }
</style>



// WEBPACK FOOTER //
// contact.vue?57f82f3c